var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgQbIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "b",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 41.677,
    height: 39.278,
    viewBox: "0 0 41.677 39.278",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "c",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M39.697,15.05v21.084c0,1.372-1.122,2.494-2.494,2.494H4.765c-1.372,0-2.494-1.122-2.494-2.494v-15.32",
    fill: "none",
    stroke: "#73307a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.319,10.616V3.281c0-1.447,1.184-2.631,2.631-2.631h25.214",
    fill: "none",
    stroke: "#73307a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 18.277,
    cy: 9.011,
    r: 1.852,
    fill: "none",
    stroke: "#73307a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.76,
    cy: 9.011,
    r: 1.852,
    fill: "none",
    stroke: "#73307a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.502,
    cy: 16.078,
    r: 1.852,
    fill: "none",
    stroke: "#73307a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3.693,
    y1: 14.66,
    x2: 6.669,
    y2: 10.505,
    fill: "none",
    stroke: "#73307a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 14.065,
    y1: 14.66,
    x2: 17.042,
    y2: 10.505,
    fill: "none",
    stroke: "#73307a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12.089,
    y1: 14.66,
    x2: 9.112,
    y2: 10.505,
    fill: "none",
    stroke: "#73307a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13.019,
    cy: 16.48,
    r: 1.852,
    fill: "none",
    stroke: "#73307a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 19.858,
    y: 16.333,
    width: 3.305,
    height: 9.738,
    fill: "none",
    stroke: "#73307a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25.701,
    y: 19.93,
    width: 3.305,
    height: 6.141,
    fill: "none",
    stroke: "#73307a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 31.479,
    y: 21.868,
    width: 3.305,
    height: 4.203,
    fill: "none",
    stroke: "#73307a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.482,26.071h-19.103",
    fill: "none",
    stroke: "#73307a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M41.027,6.337c.021-3.048-2.454-5.524-5.502-5.504v5.504s5.502,0,5.502,0Z",
    fill: "none",
    stroke: "#73307a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.728,9.189V2.996c-3.379.022-6.111,2.767-6.111,6.151,0,.014,0,.029,0,.043.023,3.364,2.746,6.086,6.11,6.108.013,0,.027,0,.04,0,3.383,0,6.127-2.731,6.151-6.108h-6.191Z",
    fill: "none",
    stroke: "#73307a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 9.285,
    y1: 31.125,
    x2: 16.14,
    y2: 31.125,
    fill: "none",
    stroke: "#73307a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6.309,
    y1: 31.125,
    x2: 6.932,
    y2: 31.125,
    fill: "none",
    stroke: "#73307a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  })), /*#__PURE__*/React.createElement("line", {
    x1: 19.1,
    y1: 31.125,
    x2: 25.954,
    y2: 31.125,
    fill: "none",
    stroke: "#73307a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 29.074,
    y1: 31.125,
    x2: 35.928,
    y2: 31.125,
    fill: "none",
    stroke: "#73307a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 9.285,
    y1: 34.544,
    x2: 16.14,
    y2: 34.544,
    fill: "none",
    stroke: "#73307a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6.309,
    y1: 34.544,
    x2: 6.932,
    y2: 34.544,
    fill: "none",
    stroke: "#73307a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  })), /*#__PURE__*/React.createElement("line", {
    x1: 19.1,
    y1: 34.544,
    x2: 25.954,
    y2: 34.544,
    fill: "none",
    stroke: "#73307a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 29.074,
    y1: 34.544,
    x2: 35.928,
    y2: 34.544,
    fill: "none",
    stroke: "#73307a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  })))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQbIcon);
export default __webpack_public_path__ + "static/media/QB-Icon.edb0c90d.svg";
export { ForwardRef as ReactComponent };